import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  productType: {
    display: 'flex',
    alignItems: 'center',
  },

  productTypeName: {
    marginRight: '.4rem',
  },
})

export default useStyles
